import { formatRecordData } from '../utils/utilities'
import MemoryStore from '../utils/memory-store'
import KeywordsFormContainer from '../keywords/containers/keywords-form-container'
import Enums from '../utils/enums'

export const filterViewData = (viewData, searchFilter) => {
  searchFilter = searchFilter.toLowerCase()

  if (searchFilter === '') {
    return viewData
  } else {
    return viewData.filter(t =>
      (
        (t.data.key.toLowerCase().indexOf(searchFilter) > -1) ||
        (t.data.values.filter(v =>
          (
            (v.label.toLowerCase().indexOf(searchFilter) > -1) ||
            (v.value.toLowerCase().indexOf(searchFilter) > -1)
          )
        )).length > 0
      )
    )
  }
}

export const formatRecord = (entry, data) => {
  let tempIndex = 0

  entry = formatRecordData(entry)
  entry.key = entry._id // Needed for View's Unique key requirement
  entry.data.isActiveDescription = entry.data.isActive ? 'Yes' : 'No' // Needed for View Column

  if (entry.custom.isNewDoc) {
    // Add new Entry to State
    entry.custom.isNewDoc = false
    entry.custom.action = 'create'
    data.push(entry)
  } else {
    if (entry.custom.isSavedDoc) {
      entry.custom.action = 'update'
    } else {
      entry.custom.action = 'create'
    }

    // Update Entry in State
    tempIndex = data.findIndex(t => t._id === entry._id)
    data[tempIndex] = entry
  }

  return data
}

export const cleanupData = (data) => {
  let entry = null
  const tempArray = data.concat()

  // First Strip empty values from array
  for (let x = 0, y = tempArray.length; x < y; x++) {
    entry = tempArray[x]

    if ((entry.label.trim() === '') && (entry.value.trim() === '')) {
      tempArray.splice(x, 1)
      x--
      y = tempArray.length
    }
  }

  // Next, trim labels and values
  for (const x in tempArray) {
    entry = tempArray[x]

    entry.label = entry.label.trim()
    entry.value = entry.value.trim()
  }

  return tempArray
}

export const createCopy = (currEntryData, callback) => {
  const newEntry = JSON.parse(JSON.stringify(MemoryStore.keywords.dataTemplate))
  newEntry._id = new Date().getTime().toString()
  newEntry.custom.tempId = newEntry._id

  const entryData = JSON.parse(JSON.stringify(currEntryData))
  const tabType = Enums.VALUES_STRINGS.FORM
  const content = KeywordsFormContainer
  const closable = true
  const key = newEntry._id
  const app = Enums.APP_IDS.KEYWORDS

  let title = Enums.APP_PROFILE_TITLES.keywords + Enums.VALUES_STRINGS.COLON + Enums.VALUES_STRINGS.SPACE
  let payload = {}

  // create unique key
  entryData.key = currEntryData.key + '_copy'

  newEntry.data = entryData

  title += entryData.key

  payload = {
    content,
    title,
    key,
    app,
    tabType,
    closable
  }

  MemoryStore.activeEntries[newEntry._id] = newEntry

  callback(payload)
}
